<template>
  <div class="step step_4"  :class="{'form__step_hidden': step != number}">
    <h3 class="form__title">Паспортные данные застрахованного лица</h3>
    <TextInput :disabled="copy" :errorcont="errorcont" mask="####-######" :filled="(v)=>v.length==11" :value="stepsdata[currentnumber][getName(names[0])]" @input="$set(stepsdata[number],names[0], $event)" :name="names[0]" :increased="!stepsdata[number][names[0]]" text="Серия и номер*" :required="true"/>
    <TextInput :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[1])]" @input="$set(stepsdata[number],names[1], $event)" :name="names[1]" :increased="!stepsdata[number][names[1]]" text="Кем выдан*" :required="true"/>
    <ShortFields>
      <DateInput :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[2])]" @input="$set(stepsdata[number],names[2], $event)" :name="names[2]" :increased="!stepsdata[number][names[2]]" text="Дата выдачи*" :required="true"/>
      <NumberInput :disabled="copy" :errorcont="errorcont" mask="############" :validation="(v)=>!(v.match(/^[0-9]{10}$/)||v.match(/^[0-9]{12}$/))?'10 или 12 символов':''" :value="stepsdata[currentnumber][getName(names[3])]" @input="$set(stepsdata[number],names[3], $event)" :name="names[3]" :increased="!stepsdata[number][names[3]]" text="ИНН"/>
    </ShortFields>
    <ShortFields>
      <TextInput :options="filterCountryList(stepsdata[number][names[4]])" :disabled="copy" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[4])]" @input="$set(stepsdata[number],names[4], $event)" :name="names[4]" :increased="!stepsdata[number][names[4]]" text="Гражданство*" :required="true"/>
      <SelectInput :disabled="copy" :options="['','Женат/замужем','Не женат/не замужем','Разведен/разведена']" :errorcont="errorcont" :value="stepsdata[currentnumber][getName(names[5])]" @input="$set(stepsdata[number],names[5], $event)" :name="names[5]" :increased="!stepsdata[number][names[5]]" text="Семейное положение*" :required="true"/>
    </ShortFields>
    <CheckboxInput :disabled="copy" :value="stepsdata[currentnumber][getName(names[6])]" @input="$set(stepsdata[number],names[6], $event)" :name="names[6]" descr="Являетесь ли вы иностранным публичным должностным лицом, его супругом, близким родственником (родственником по прямой восходящей или нисходящей линии (родителем или ребенком, дедушкой, бабушкой или внуком), полнородными или неполнородными (имеющим общего отца или мать) братом или сестрой, усыновителем или усыновленным)?" :required="true"/>

    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import TextInput from '@/components/TextInput.vue'
import { mapState } from 'vuex'
import ShortFields from './ShortFields.vue'
import CheckboxInput from './CheckboxInput.vue'
import NumberInput from './NumberInput.vue'
import DateInput from './DateInput.vue'
import FilterCountryList from '../mixins/FilterCountryList.vue'
import SelectInput from './SelectInput.vue'
export default {
  mixins: [FilterCountryList],
  components: { Btn, TextInput, ShortFields, CheckboxInput, NumberInput, DateInput, SelectInput },
  data: ()=>({
    names: ['repeatpolicyholderpassport','repeatpolicyholderpassportissued','repeatpolicyholderpassportdate','repeatpolicyholderINN','repeatpolicyholdercitizenship','repeatpolicyholdermarital','specialrepeatpolicyholder'],
    errorcont: {},
  }),
  props: {
    number: {type: Number, default: 8},
    copyslidenumber: {type: Number, default: 4},

  },
  methods:{
    getName(name){
      if (this.copy)
        return name.replace('repeatpolicyholder', 'client')
      return name
    }
  },
  computed: {
    ...mapState(['stepsdata','step', 'copy']),
    currentnumber(){
      return this.copy?this.copyslidenumber:this.number
    },
    filled(){
      let notrequiredidx = [3,6]
      for (let [i, name] of this.names.entries()) {
        if ((!this.stepsdata[this.number][name] && !notrequiredidx.includes(i)) || this.errorcont[name])
          return false
      }
      return  true
    }
  },
}
</script>

<style lang="sass">

</style>